import React from 'react';
import { useParams } from 'react-router';
import CareersBrandHeader from './CareersBrandHeader';

/**
 * The bar above an application: the organization being applied to, not the
 * product. The address names only the job, so that is what is asked about.
 */
const ApplyJobHeader = () => {
  const { id } = useParams();
  return <CareersBrandHeader jobId={id} context="Apply for this job" />;
};

export default ApplyJobHeader;
